// extracted by mini-css-extract-plugin
module.exports = {"crate-index__subtitle":"crate_crate-index__subtitle__7rfQa"};